import { setStorageImport } from './storage-import.js';

import { transience, localStorage } from './internal/index.js';

function load(imp) {
    setStorageImport(imp);

    const { tvalue, tset, treset, lvalue, lset, lreset } = imp;

    transience.init(tvalue, tset, treset);
    localStorage.init(lvalue, lset, lreset);
}

export { load };
